import React from 'react';
import config from '../config';

const AboutPage: React.FC = () => {
  return (
    <main className="bg-white py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-white shadow-lg rounded-lg p-8">
          <h1 className="text-4xl font-bold text-center mb-8 text-indigo-900">{config.pages.about.title}</h1>
          <div className="prose max-w-none text-gray-800">
            <img src={config.pages.about.imageUrl} alt={config.candidateName} className="w-1/2 mx-auto mb-8 rounded-lg" />
            <p>{config.pages.about.text}</p>
          </div>
        </div>
      </div>
    </main>
  );
};

export default AboutPage;
